import { render } from "./ReferenceProfileEditForm.vue?vue&type=template&id=bc2c730c&scoped=true"
import script from "./ReferenceProfileEditForm.vue?vue&type=script&lang=js"
export * from "./ReferenceProfileEditForm.vue?vue&type=script&lang=js"

import "./ReferenceProfileEditForm.vue?vue&type=style&index=0&id=bc2c730c&scoped=true&lang=scss"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc2c730c"]])

export default __exports__